import _styled, { default as _styled2 } from "styled-components";
var _class, _MyDataTab, _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import Icon from "../../../../Styled/Icon";
import Box from "../../../../Styled/Box";
import PropTypes from "prop-types";
import DataPreview from "../../../Preview/DataPreview.jsx";
import AddData from "./AddData.jsx";
import { withTranslation, Trans } from "react-i18next";
import Styles from "./my-data-tab.scss";
import DataCatalogMember from "../../../DataCatalog/DataCatalogMember";

// My data tab include Add data section and preview section
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
let MyDataTab = observer(_class = (_MyDataTab = class MyDataTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: null
    };
  }
  hasUserAddedData() {
    return this.props.terria.catalog.userAddedDataGroup.members.length > 0;
  }
  changeTab(active) {
    this.setState({
      activeTab: active
    });
  }
  resetTab() {
    this.setState({
      activeTab: null
    });
  }
  renderTabs() {
    const {
      t
    } = this.props;
    const tabs = [{
      id: "local",
      caption: t("addData.localTitle")
    }, {
      id: "web",
      caption: t("addData.webTitle")
    }];
    return /*#__PURE__*/_jsx("ul", {
      className: Styles.tabList,
      children: tabs.map(tab => /*#__PURE__*/_jsx("li", {
        className: Styles.tabListItem,
        children: /*#__PURE__*/_jsxs(_StyledButton, {
          type: "button",
          onClick: () => this.changeTab(tab.id),
          title: tab.caption,
          className: classNames(Styles.tabListBtn, {
            [Styles.isActive]: this.state.activeTab === tab.id
          }),
          children: [/*#__PURE__*/_jsx(Icon, {
            glyph: Icon.GLYPHS[tab.id]
          }), tab.caption]
        })
      }, tab.id))
    });
  }
  renderPromptBox() {
    if (this.hasUserAddedData()) {
      const {
        t
      } = this.props;
      return /*#__PURE__*/_jsx("div", {
        className: Styles.dataTypeTab,
        children: /*#__PURE__*/_jsxs("div", {
          className: Styles.dndBox,
          children: [/*#__PURE__*/_jsx(Icon, {
            glyph: Icon.GLYPHS.upload
          }), t("addData.dragDrop")]
        })
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      className: Styles.dataTypeTab,
      children: [/*#__PURE__*/_jsxs("div", {
        className: Styles.dndBoxInfo,
        children: [/*#__PURE__*/_jsxs(Trans, {
          i18nKey: "addData.infoText",
          children: [/*#__PURE__*/_jsx("div", {
            children: "Drag and drop a file here to view it locally on the map"
          }), /*#__PURE__*/_jsx("div", {
            children: "(it won\u2019t be saved or uploaded to the internet)"
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: Styles.tabCenter,
          children: this.renderTabs()
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: Styles.dndBox,
        children: /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.upload
        })
      })]
    });
  }
  render() {
    const showTwoColumn = !!(this.hasUserAddedData() && !this.state.activeTab);
    const {
      t,
      className
    } = this.props;
    return /*#__PURE__*/_jsxs(Box, {
      className: classNames(Styles.root, {
        [className]: className !== undefined
      }),
      children: [/*#__PURE__*/_jsxs("div", {
        className: classNames({
          [Styles.leftCol]: showTwoColumn,
          [Styles.oneCol]: !showTwoColumn
        }),
        children: [this.state.activeTab && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(_StyledButton2, {
            type: "button",
            onClick: () => this.resetTab(),
            className: Styles.btnBackToMyData,
            children: [/*#__PURE__*/_jsx(Icon, {
              glyph: Icon.GLYPHS.left
            }), t("addData.back")]
          }), /*#__PURE__*/_jsx(AddData, {
            terria: this.props.terria,
            viewState: this.props.viewState,
            activeTab: this.state.activeTab,
            resetTab: () => this.resetTab(),
            onFileAddFinished: this.props.onFileAddFinished,
            onUrlAddFinished: this.props.onUrlAddFinished,
            localDataTypes: this.props.localDataTypes,
            remoteDataTypes: this.props.remoteDataTypes
          })]
        }), showTwoColumn && /*#__PURE__*/_jsxs(Box, {
          flexShrinkZero: true,
          column: true,
          children: [/*#__PURE__*/_jsx("p", {
            className: Styles.explanation,
            children: /*#__PURE__*/_jsxs(Trans, {
              i18nKey: "addData.note",
              children: [/*#__PURE__*/_jsx("strong", {
                children: "Note: "
              }), "Data added in this way is not saved or made visible to others."]
            })
          }), /*#__PURE__*/_jsx("div", {
            className: Styles.tabLeft,
            children: this.renderTabs()
          }), /*#__PURE__*/_jsx("ul", {
            className: Styles.dataCatalog,
            children: this.props.terria.catalog.userAddedDataGroup.memberModels.map(item => /*#__PURE__*/_jsx(DataCatalogMember, {
              viewState: this.props.viewState,
              member: item,
              removable: true,
              terria: this.props.terria,
              isTopLevel: true
            }, item.uniqueId))
          })]
        }), !this.state.activeTab && this.renderPromptBox()]
      }), showTwoColumn && /*#__PURE__*/_jsx(Box, {
        styledWidth: "60%",
        children: /*#__PURE__*/_jsx(DataPreview, {
          terria: this.props.terria,
          viewState: this.props.viewState,
          previewed: this.props.viewState.userDataPreviewedItem
        })
      })]
    });
  }
}, _defineProperty(_MyDataTab, "propTypes", {
  terria: PropTypes.object,
  viewState: PropTypes.object,
  onFileAddFinished: PropTypes.func.isRequired,
  onUrlAddFinished: PropTypes.func.isRequired,
  localDataTypes: PropTypes.arrayOf(PropTypes.object),
  remoteDataTypes: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  t: PropTypes.func.isRequired
}), _MyDataTab)) || _class;
export default withTranslation()(MyDataTab);
var _StyledButton = _styled("button")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                color: ", ";\n                &:hover,\n                &:focus {\n                  color: ", ";\n                }\n                svg {\n                  fill: ", ";\n                }\n              "])), p => p.theme.colorPrimary, p => p.theme.grey, p => p.theme.colorPrimary);
var _StyledButton2 = _styled2("button").withConfig({
  displayName: "MyDataTab___StyledButton2",
  componentId: "sc-1gebyzu-0"
})(["color:", ";&:hover,&:focus{border:1px solid ", ";}svg{fill:", ";}"], p => p.theme.colorPrimary, p => p.theme.colorPrimary, p => p.theme.colorPrimary);